import SEO from "@/components/SEO";
import { PageHero, Reveal, LegalText } from "@/components/Bits";
import { PRIVACY_TXT } from "@/content/policies";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <SEO
        title="Privacy Policy"
        description="How Middle Man (Tourist Junction Private Limited) collects, uses, shares and protects your personal information across the app and product marketplace. Effective 10 September 2026."
        path="/privacy"
      />
      <PageHero
        kicker="Legal"
        title="Privacy Policy"
        subtitle="Effective from: 10 September 2026 · Applies to the Middle Man app, the product marketplace and this website."
      />
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-20">
        <Reveal>
          <LegalText text={PRIVACY_TXT} />
        </Reveal>
      </div>
    </div>
  );
}
